import React, { useContext, useEffect, useMemo, useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';

import { Template, TemplateFilter, search, excluir, viewArquivo, downloadArquivo, baixarTudo } from '@app/api/template';
import { getTipoServicoOptions } from '@app/api/tipoServico';
import { SearchButton } from '@app/components/FormButtons';
import { GetFileExtension, imageFormats } from '@app/helpers';
import { hasPermission } from '@app/helpers/permissions';
import {
  Button,
  ButtonDelete,
  ColumnProps,
  CompositeView,
  FilterWidget,
  FormContext,
  FormInput,
  FormSelect,
  GridView,
  SimpleView,
  Table,
  Widget,
} from '@digital/ui';
import { Tooltip, Icon } from 'antd';

import ModalCreateFrom from './ModalCreateForm';
import { getDescricoesDocumentoOptions } from '@app/api/demanda';
import './templates.css';
import { FormikProps } from 'formik';

const Templates = () => {
  const [items, setItems] = useState<Template[]>();
  const [getList, setGetList] = useState<boolean>(true);
  const [filter, setFilter] = useState<TemplateFilter>({});
  const [tipoServicoOptions, setTipoServicoOptions] = useState([]);
  const [descricaoDocumentoOptions, setDescricaoDocumentoOptions] = useState([]);

  const onUpdate = () => {
    setGetList(!getList);
  };

  useEffect(() => {
    handleFilter(filter);
  }, [getList]);

  const handleFilter = (values: TemplateFilter) => {
    search(values).then(resp => resp && setItems(resp));
    setFilter(values);
  };

  const handleCleanFilter = (formProps: FormikProps<any> | undefined) => {
    formProps && formProps.setFieldValue('tipoServicoId', null);
    formProps && formProps.setFieldValue('descricaoDocumento', null);
    search({}).then(resp => resp && setItems(resp));
    setFilter({});
  };

  const handleExcluir = (id: string) => {
    excluir(id).then(data => {
      if (data.valid) {
        onUpdate();
      }
    });
  };

  useEffect(() => {
    getTipoServicoOptions().then(data => {
      setTipoServicoOptions(data);
    });
    getDescricoesDocumentoOptions().then(data => {
      setDescricaoDocumentoOptions(data);
    });
  }, []);

  const handleBaixarTudo = () => {
    baixarTudo(filter);
  };

  const columns = () => {
    const columns: ColumnProps<any>[] = [];

    columns.push({
      title: 'Tipo de Serviço',
      dataIndex: 'tipoServico.nome',
      render: (index, record) => (record.tipoServico ? record.tipoServico.nome : ''),
    });

    columns.push({
      title: 'Descrição Documento',
      dataIndex: 'descricaoDocumento',
    });

    columns.push(
      {
        title: 'Nome Arquivo',
        dataIndex: 'arquivo.nome',
        render: (index, record) => (record.arquivo ? record.arquivo.nome : ''),
      },
      {
        title: 'Ações',
        width: '2%',
        render: (index, record) => (
          <>
            {record.arquivo && (
              <>
                <Tooltip title="Download Arquivo">
                  <Button
                    icon="ui-download"
                    type="link"
                    key="downloadButton"
                    onClick={() => {
                      downloadArquivo(record.arquivo.id, record.arquivo.nome);
                    }}
                  />
                </Tooltip>
                {GetFileExtension(record.arquivo.nome) === 'pdf' ||
                  imageFormats.includes(GetFileExtension(record.arquivo.nome)) ? (
                  <Tooltip title="Visualizar Arquivo">
                    <Button
                      icon="files-view_file"
                      type="link"
                      key="viewButton"
                      onClick={() => {
                        viewArquivo(record.arquivo.id, record.arquivo.nome);
                      }}
                    />
                  </Tooltip>
                ) : (
                  <></>
                )}
              </>
            )}
            {hasPermission(['PRE_SUPRIMENTOS_TEMPLATES_EXCLUIR']) && (
              <Tooltip title="Excluir">
                <Button
                  confirm="Deseja realmente excluir este registro?"
                  okText="Confirmar"
                  icon="science-minus"
                  type="link"
                  title=""
                  key="excluirButton"
                  onClick={() => {
                    handleExcluir(record.id);
                  }}
                />
              </Tooltip>
            )}
          </>
        ),
      },
    );

    return columns;
  };

  return (
    <CompositeView>
      <SimpleView>
        <GridView>
          <FormContext.Consumer>
            {({ formProps }) => (
              <FilterWidget
                actions={[
                  <>
                    <Button type="primary" key="cleanFilterBtn" title="Limpar Filtros" onClick={() => handleCleanFilter(formProps)} />
                    <SearchButton type="primary" key="filterBtn" onClick={handleFilter} />
                  </>
                ]}
                title="Filtros">
                <FormSelect
                  id="mrn-select-tipoServico"
                  allowClear
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, item) => {
                    return item.props.children.props.id.toString().toLowerCase().includes(input.toLowerCase());
                  }}
                  label="Tipo de Serviço"
                  options={tipoServicoOptions}
                  name="tipoServicoId"
                  span={6}
                />
                {hasPermission(['PRE_SUPRIMENTOS_TEMPLATES_VISUALIZAR_DETALHES']) && (
                  <FormSelect
                    allowClear
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, item) => {
                      return item.props.children.props.id.toString().toLowerCase().includes(input.toLowerCase());
                    }}
                    label="Descrição do Documento"
                    options={descricaoDocumentoOptions}
                    name="descricaoDocumento"
                    span={6}
                  />
                )}
              </FilterWidget>
            )}
          </FormContext.Consumer>
          <Widget
            className="widgetTable"
            actions={[
              <>
                {hasPermission(['PRE_SUPRIMENTOS_TEMPLATES_CADASTRAR']) ? <ModalCreateFrom onUpdate={onUpdate} /> : <></>}
              </>,
              <Button onClick={() => handleBaixarTudo()}>Baixar Tudo</Button>,
            ]}>
            <PerfectScrollbar className="scrollbarTemplate">
              <Table
                columns={columns()}
                rowKey="id"
                key="id"
                dataSource={items}
                pagination={false}
                style={{ overflowY: 'auto' }}
              />
            </PerfectScrollbar>
          </Widget>
        </GridView>
      </SimpleView>
    </CompositeView>
  );
};

export default Templates;
